import { PublishedListingsState } from '@app/store/publishedListings'

import { useAppSelector } from './useAppSelector'

export const usePublishedListings = (): PublishedListingsState =>
  useAppSelector((state) => state.publishedListings)
